import { render, staticRenderFns } from "./curso.vue?vue&type=template&id=73c75a94&scoped=true&"
import script from "./curso.vue?vue&type=script&lang=ts&"
export * from "./curso.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c75a94",
  null
  
)

export default component.exports